<template>
  <div class="container" v-loading="loading" element-loading-text="Cargando datos..."
    element-loading-spinner="el-icon-loading" element-loading-background="rgb(237 237 237 / 80%)">
    <header class="clearfix">
      <div id="logo-print">
        <img class="logo-print" :src="pahtImages + 'logo.webp'" alt="logo" />
      </div>
      <h1 v-bind:style="{ 'background-image': 'url(' + pahtImages + 'dimension.png)' }">
        {{ titleDocument }}
      </h1>
      <div id="company" class="clearfix">
        <div>&nbsp;</div>
        <!-- <hr> -->
        <div><strong>Fecha: </strong> {{ document.fecha }}</div>
        <div><strong>Contenedor: </strong> {{ branch.nit }}</div>
        <div><strong>Documento de referencia: </strong> {{ document.document_reference }}</div>
        <!-- <div>{{ branch.razon_social }}</div> -->
      </div>
      <div id="project">
        <div><strong>Responsable:</strong></div>
        <!-- <hr> -->
        <div>{{ person.nombre }}</div>
        <div>{{ person.direccion }}</div>
        <div>{{ person.email }}</div>
        <div>{{ person.telefono }}</div>
      </div>
    </header>
    <main>
      <table>
        <thead>
          <tr>
            <th>CÓDIGO</th>
            <th>UBICACIÓN</th>
            <th class="desc">DESCRIPCIÓN</th>
            <th>CANTIDAD</th>
            <th>COSTO</th>
            <th>P. VENTA</th>
            <th>OBSERVACIÓN</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in detail">
            <td class="service">{{ item.product.codigo }}</td>
            <td class="service">{{ item.in_location }}</td>
            <td class="desc">{{ item.descripcion }}</td>
            <td class="unit">{{ item.cantidad }}</td>
            <td class="price">$ {{ item.costo }}</td>
            <td class="price">$ {{ item.precio }}</td>
            <td class="desc">{{ item.observacion }}</td>
          </tr>

          <!-- <tr>
            <td colspan="4" class="grand total">GRAND TOTAL</td>
            <td class="grand total">$6,500.00</td>
          </tr> -->
        </tbody>
      </table>
      <div id="notices">
        <div>Observaciones:</div>
        <div class="notice">{{ document.observacion }}</div>
      </div>
    </main>
    <footer>
      Invoice was created on a computer and is valid without the signature and seal.
    </footer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "FormatOneComponent",
  computed: {
    ...mapGetters(['dataPrint'])
  },
  watch: {
    dataPrint: {
      deep: true,
      handler(val, oldVal) {
        this.loading = true
        if (val) {
          this.setData()
        } else {
          this.loading = false
        }
      },
    },
  },
  data() {
    return {
      loading: true,
      pahtImages: process.env.VUE_APP_ROOT + 'images/',
      titleDocument: '',
      branch: '',
      person: '',
      detail: '',
      document: '',
    };
  },
  methods: {
    async setData() {
      let me = this
      me.titleDocument = me.dataPrint.document.type.descripcion + ' (' + me.dataPrint.document.type.prefijo + ') #' + me.dataPrint.document.consecutivo
      me.branch = me.dataPrint.document.branch
      me.person = me.dataPrint.document.person
      me.detail = me.dataPrint.detail
      me.document = me.dataPrint.document
      setTimeout(() => {
        me.loading = false
      }, 1000);
    }
  }
};
</script>
<style lang="scss" scoped>
footer {
  visibility: hidden;

  @media print {
    visibility: visible;
  }
}

header,
main,
footer {
  min-width: 500px;
}

.container {
  margin-top: 10px;
  width: 100%;

  @media print {
    height: 100vh;
  }

}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #5D6975;
  text-decoration: underline;
}

body {
  position: relative;
  width: 21cm;
  height: 29.7cm;
  margin: 0 auto;
  color: #001028;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-family: Arial;
}

header {
  padding: 10px 0;
  margin-bottom: 10px;

  #logo-print {
    text-align: center;

    .logo-print {
      width: 250px;
      margin-bottom: 20px;
    }
  }
}

#logo {
  text-align: center;
  margin-bottom: 10px;
}

#logo img {
  width: 90px;
}

h1 {
  border-top: 1px solid #5D6975;
  border-bottom: 1px solid #5D6975;
  color: #5D6975;
  font-size: 2em;
  line-height: 1.4em;
  font-weight: normal;
  text-align: center;
  margin: 0 0 20px 0;
  // background: url('@/assets/logo-2inventario-min.png');
}

#project {
  float: left;
}

#project span {
  color: #5D6975;
  text-align: right;
  width: 52px;
  margin-right: 10px;
  display: inline-block;
  font-size: 0.8em;
}

#company {
  float: right;
  text-align: right;
  margin-right: 20px;
}

#project div,
#company div {
  white-space: nowrap;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
}

table tr:nth-child(2n-1) td {
  background: #F5F5F5;
}

table th,
table td {
  text-align: center;
}

table th {
  padding: 5px 20px;
  color: #5D6975;
  border-bottom: 1px solid #C1CED9;
  white-space: nowrap;
  font-weight: normal;
}

table .service,
table .desc {
  text-align: left;
}

table td {
  padding: 10px;
  text-align: right;
  font-size: 0.9em;
}

table td.service,
table td.desc {
  vertical-align: top;
}

table td.unit,
table td.qty table td.total {
  font-size: 1em;
}

table td.unit {
  text-align: center;
}

table td.grand {
  border-top: 1px solid #5D6975;
}

#notices .notice {
  color: #5D6975;
  font-size: 1.2em;
}

footer {
  color: #5D6975;
  width: 100%;
  height: 30px;
  border-top: 1px solid #C1CED9;
  padding: 8px 0;
  text-align: center;
  bottom: 0;

  @media print {
    position: absolute;
  }
}
</style>